import React from 'react';

export function ModalPriceDotLegend() {
	return (
		<div className='pt-3 font-display text-labelsmall font-semibold text-gray-500 leading-normal'>
			<div className='flex items-center justify-end_'>
				<span className='flex-none w-2 h-2 mr-1.5 grow-0 shrink-0 rounded-full bg-green-500'></span>
				Settings from Price Monitor database
			</div>
			<div className='flex items-center justify-end_'>
				<span className='flex-none w-2 h-2 mr-1.5 grow-0 shrink-0 rounded-full bg-yellow-500'></span>
				Settings input from user, not Price monitor
			</div>
			<div className='flex items-center justify-end_'>
				<span className='flex-none w-2 h-2 mr-1.5 grow-0 shrink-0 rounded-full bg-red-500'></span>
				No price available from the Price Monitor database
			</div>
		</div>
	);
}
